import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { DatosFechas } from '../../../../models/datos-Fechas';
import { DatosFechasService } from '../../../../services/datos-fechas.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-datos-fechas-list',
  templateUrl: './datos-fechas-list.component.html',
  styleUrls: ['./datos-fechas-list.component.css']
})
export class DatosFechasListComponent implements OnInit {

  @Input() personalId: number;
  @Input() datosFechas: DatosFechas[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<DatosFechas>();
    
  datosFechasOri: DatosFechas[];
  datosFechasGrupo: DatosFechas[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private fechasSrv: DatosFechasService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.datosFechasOri = this.datosFechas;
    this.inicializaFiltros();
    
    this.filtrarDatosFechas();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarDatosFechas()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.datosFechas = this.datosFechasOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.datosFechasGrupo == undefined)
      {
        this.fechasSrv.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
              currentValue.fechaEvento = this.momentService.convertDateServer(currentValue.fechaEvento);
            });

            this.datosFechasGrupo = data;
            this.datosFechas = this.datosFechasGrupo;
          });

      } else
      {
        this.datosFechas = this.datosFechasGrupo;
      }
      
    } else
    {
      this.filtrarDatosFechas();
    }
  }

  onChangeFiltros()
  {
    this.filtrarDatosFechas();
  }

  visualizarDetalle(datoFecha)
  {
    this.VisualizarDetalle.emit(datoFecha);
  }

  add()
  {
    let datoFecha: DatosFechas = { id: 0, personal: this.personalId, desde: new Date().toString(), hasta: new Date("2999-12-31T23:59:59").toString()};
    this.VisualizarDetalle.emit(datoFecha);
  }

}

